export default __webpack_public_path__ + "static/media/hamburger.14cb7bb6.svg";